import type { AutocompleteValue, TextFieldProps } from '@mui/material';
import type { OptionValue } from 'components/common/CheckboxAutocomplete';
import CheckboxAutocomplete from 'components/common/CheckboxAutocomplete';
import type { AutocompleteProps } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAdBranchesOptions } from '../api/getAdBranches';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';

interface CompanyAutocompleteProps extends Omit<
  AutocompleteProps<number, true, boolean, false>,
  'value' | 'onChange' | 'options' | 'renderInput'
> {
  value?: AutocompleteValue<number, true, false, false>;
  onChange: (value: AutocompleteValue<number, true, false, false>) => void;
  InputProps?: TextFieldProps;
  allowedValues: number[];
}

const BranchesAutocomplete = ({ InputProps, value, onChange, allowedValues, ...props }: CompanyAutocompleteProps) => {
  const { network, region } = useFacebookAdsLibraryParams();
  const { data } = useSuspenseQuery({
    ...getAdBranchesOptions({ network, region }),
    select: (d) =>
      d
        .map(({ id, name }) => ({ label: name, value: id }))
        .filter(({ value }) => allowedValues.includes(value)),
  });

  return (
    <CheckboxAutocomplete
      {...props}
      value={value}
      onChange={onChange as (value: OptionValue[]) => void}
      InputProps={InputProps}
      id="branches-autocomplete"
      options={data}
    />
  );
};
export default BranchesAutocomplete;
